import React from "react"
import { Heading } from "@indeed/ifl-components"
import { useI18n } from "../../common/utils/i18n-context"
import { useAppSelector } from "../../common/utils/redux-helpers"
import { pauseDataSelector, selectedDurationUnitsAsString, isPausedSelector } from "./pause-slice"

export const PauseHeader: React.FC = () => {
    const pauseData = useAppSelector(pauseDataSelector)
    const durationUnitsString = useAppSelector(selectedDurationUnitsAsString)
    const isPaused = useAppSelector(isPausedSelector)
    const { gettext } = useI18n()

    return (
        <Heading as="h1" level={4}>
            {!isPaused
                ? gettext("Got it! We won’t pause these communications.")
                : gettext("Got it! We’ll pause these communications for {0} {1}.", [pauseData.duration, durationUnitsString])}
        </Heading>
    )
}
